import { render, staticRenderFns } from "./VDraggable.vue?vue&type=template&id=51ba77aa&scoped=true"
import script from "./VDraggable.vue?vue&type=script&lang=js"
export * from "./VDraggable.vue?vue&type=script&lang=js"
import style0 from "./VDraggable.vue?vue&type=style&index=0&id=51ba77aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba77aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
